import Vue from 'vue'
import Router from 'vue-router'

import StartMenu from './views/StartMenu.vue'
import Config from './views/Config.vue'
import Player from './views/Player.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/start',
      name: 'start',
      component: StartMenu,
    },
    {
      path: '/config',
      name: 'config',
      component: Config,
    },
    {
      path: '/player',
      name: 'player',
      component: Player,
    },
    {
      path: '/',
      redirect: 'start',
    },
  ],
})
